var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { action, makeAutoObservable, observable } from "mobx";
var RecentChangesStore = /** @class */ (function () {
    function RecentChangesStore() {
        Object.defineProperty(this, "filterpanelStates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                region: [],
                marketId: [],
                country: undefined,
                month: 1
            }
        });
        Object.defineProperty(this, "selectedCountry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        makeAutoObservable(this, {
            filterpanelStates: observable,
            setFilterPanelStore: action,
            selectedCountry: observable,
            setSeletedCountry: action
        });
    }
    Object.defineProperty(RecentChangesStore.prototype, "setFilterPanelStore", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, value) {
            var _a;
            this.filterpanelStates = __assign(__assign({}, this.filterpanelStates), (_a = {}, _a[key] = value, _a));
        }
    });
    Object.defineProperty(RecentChangesStore.prototype, "setSeletedCountry", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.selectedCountry = value;
        }
    });
    return RecentChangesStore;
}());
export default RecentChangesStore;
